import { AutoTooltip } from "lib/common";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import Documents from "utils/Documents";
import Money from "utils/Money";
import React from "react";

const AmountVatCell = ({ status, amountVatRates, amountBase, amountVat, currency }) => {
  if (status === DataStatuses.TO_EXTRACT) return Constants.EMPTY_PLACEHOLDER;

  const value = Documents.getAmountData(amountVatRates, amountBase, amountVat).vat;

  const content = Money.toMoneyString(value, currency);

  return <AutoTooltip active={!!value}>{content}</AutoTooltip>;
};

export default React.memo(AmountVatCell);
